import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { schemaStatisticStatus, schemaStatisticCharge, schemaStatisticLighting } from '../schemas'
import axios from 'axios'

/**
 * 获取某日的单灯统计数据
 * @param {*String} deviceId 设备id
 * @param {*String} date 日期，示例 2018-01-25
 */
export const findStatus = async (deviceId, date) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-status-hiss/get-list/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      date
    }
  })
  const { entities } = normalize(data, [ schemaStatisticStatus ])
  return fromJS(entities)
}

/**
 * 统计充放电量
 * @param {*String} deviceId 设备id
 * @param {*String} beginDate 起始日期，示例 2018-01-25
 * @param {*String} endDate 结束日期，示例 2018-01-26
 */
export const findCharge = async (deviceId, beginDate, endDate) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-status-hiss/get-charge/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      beginDate,
      endDate
    }
  })
  const { entities } = normalize(data, [ schemaStatisticCharge ])
  return fromJS(entities)
}

/**
 * 统计亮灯时间
 * @param {*String} deviceId 设备id
 * @param {*String} beginDate 起始日期，示例 2018-01-25
 * @param {*String} endDate 结束日期，示例 2018-01-26
 */
export const findLighting = async (deviceId, beginDate, endDate) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-status-hiss/get-light-time/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      beginDate,
      endDate
    }
  })
  const { entities } = normalize(data, [ schemaStatisticLighting ])
  return fromJS(entities)
}

/**
 * 获取项目概览信息
 * @param {*String} projectId 项目id
 */
export const findCount = async (projectId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/project-overviews/${projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data: { allCount, lightCount, onlineCount, errorCount, electrifyCount } } = await axios.get(path)
  return fromJS({
    [projectId]: {
      all: allCount,
      light: lightCount,
      electrify: electrifyCount,
      online: onlineCount,
      error: errorCount
    }
  })
}

/**
 * 获取月天气情况
 * @param {*String} areaCode 城市编码
 * @param {*String} month 月份 201806
 */
export const findMonthWeather = async (areaCode, month) => {
  const { data } = await axios.get(`t/wea_history/js/${month}/${areaCode}_${month}.js`)
  return data
}

/**
 * 获取月天气情况
 * @param {*String} timeType 时间类型（日-day；月-month；年-year）
 */
export const findSystemStatistics = async (timeType) => {
  const { data } = await axios.get(`v2/system-statistics/list-by-time-type?timeType=${timeType}`)
  return data
}

/**
 * 获取当前用户设备地区统计列表
 * @param {String} adCode 不传则查各个省
 */
export const findMoteInArea = async () => {
  const { data } = await axios.get(`v2/solar-motes/list-moteAreaStatistics`)
  return data
}

/**
 * 获取过去一个小时系统发电量区间接口
 */
export const findChargeInterval = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-charge-interval`)
  return data
}

/**
 * 获取系统的设备概览
 */
export const findSystemMotes = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-system-mote-overview`)
  const data1 = await axios.get(`repower/v2/system-statistics/get-system-mote-overview`)
  let arr = {
    allCount: data.allCount + data1.data.allCount,
    errorCount: data.errorCount + data1.data.errorCount,
    lightCount: data.lightCount + data1.data.lightCount,
    onlineCount: data.onlineCount + data1.data.onlineCount
  }
  return arr
}

/**
 * 获取系统节能减排收益接口
 */
export const findSystemEnergySavingIncome = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-energy-saving-income`)
  return data
}

/**
 * 获取分组月充放电量统计
 * @param {*String} options.projectId 项目id
 * @param {*String} options.groupId 分组id
 * @param {*String} options.beginDate 起始日期
 * @param {*String} options.endDate 结束日期
 */
export const findGroupByMonth = async (options) => {
  const { data } = await axios.get(
    `v2/solar-mote-status-hiss/get-solar-statistics-group-month?projectId=${options.projectId}
    &groupId=${options.groupId}&beginDate=${options.beginDate}&endDate=${options.endDate}`)
  return data
}

/**
 * 获取项目月充放电量统计
 * @param {*String} options.projectId 项目id
 * @param {*String} options.beginDate 起始日期
 * @param {*String} options.endDate 结束日期
 */
export const findProjectByMonth = async (options) => {
  const { data } = await axios.get(
    `v2/solar-mote-status-hiss/get-solar-statistics-project-month?projectId=${options.projectId}
    &beginDate=${options.beginDate}&endDate=${options.endDate}`
  )
  return data
}

/**
 * 获取项目历史总充放电量
 * @param {*String} projectId 项目id
 */
export const findProjectHis = async (projectId) => {
  const { data } = await axios.get(`v2/solar-mote-status-hiss/get-solar-statistics-project-his?projectId=${projectId}`)
  return data
}

/**
 * 获取当前用户系统充放电量月统计
 */
export const findMyElecByMonth = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-my-month-system-statistic`)
  return data
}

/**
 * 获取当前用户系统节能减排收益接口
 */
export const findMyEnergySavingIncome = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-my-energy-saving-income`)
  return data
}

/**
 * 获取当前用户的系统设备概览
 */
export const findMyMotesOverview = async () => {
  const { data } = await axios.get(`v2/system-statistics/get-my-system-mote-overview`)
  return data
}
